import React from 'react';
import { Link } from 'react-router-dom';
import { WfOrderConfirmationFramePreview } from '../components/frames/WfOrderConfirmationFramePreview';
import { siteConfig } from '../data/siteConfig';
import { buttonClasses } from '../utils/buttonStyles';
export function OrderConfirmation() {
  const {
    support
  } = siteConfig;
  return <div className="mx-auto grid max-w-page gap-14 px-5 py-14 md:px-10 md:py-20 lg:grid-cols-[1fr_1.1fr] lg:gap-24" data-id="element-551" data-mp="u11a3mvz8w2x">
      <div data-id="element-552" data-mp="1hnzomf0jdty7">
        <span aria-hidden="true" className="block h-px w-12 bg-bronze" data-id="element-553" data-mp="1ho9iidopcl96" />
        <h1 className="mt-8 font-display text-[46px] font-medium leading-[1.03] text-ink md:text-[64px]" data-id="element-554" data-mp="1modze4tivhzx">
          Thank you for your order.
        </h1>
        <p className="mt-5 max-w-md text-[17px] leading-relaxed text-ink-muted" data-id="element-555" data-mp="1cqg97bs3rb4o">
          Your order details are below. For anything about your order, call{' '}
          <a href={support.phoneHref} className="font-medium text-ink underline underline-offset-4" data-id="element-556" data-mp="3thzlyu2wx5is">
            {support.phone}
          </a>
          .
        </p>
        <Link to="/" className={`${buttonClasses('secondary')} mt-10`} data-id="element-557" data-mp="3uizae2ogfece">
          Back to home
        </Link>
      </div>
      <div className="lg:pt-3" data-id="element-558" data-mp="3pl7gj3491i5k">
        <WfOrderConfirmationFramePreview data-id="element-559" data-mp="7d8armb1w3d0" />
      </div>
    </div>;
}